import { AMEND, CANCEL, CARRY_ON, CHECK_IN, MEAL, SEAT } from '@/src/constants/itinerary/fareFamily'
import { useTranslations } from 'next-intl'

const useFareFamilyDisplayName = () => {
    const t = useTranslations('common')
    const getBenefitDisplayName = (benefitKey: string) => {
        switch (benefitKey) {
            case CARRY_ON:
                return t('cabinBagAdult')
            case CHECK_IN:
                return t('checkInBagAdult')
            case CANCEL:
                return t('refundOnCancellation')
            case AMEND:
                return t('dateChangeFees')
            case SEAT:
                return t('seat')
            case MEAL:
                return t('meal')
            default:
                return ''
        }
    }
    return getBenefitDisplayName
}

export default useFareFamilyDisplayName
